import { PM_PROVIDERS } from 'common/constants/constants';
import { mapPmProviderToViewer } from 'common/hooks/pm/usePmViewer/usePmViewer.utils';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import store from 'state/store/configureStore';

export const jiraViewer = mapPmProviderToViewer(PM_PROVIDERS.JIRA);

export const azureBoardsViewer = mapPmProviderToViewer(
  PM_PROVIDERS.AZURE_BOARDS
);

export const getPmViewerFromStore = () => {
  try {
    const pmProvider = pmToolSensorIdSelector(store.getState());
    const pmViewer = mapPmProviderToViewer(pmProvider);
    return pmViewer;
  } catch (e) {
    return jiraViewer;
  }
};
